export default __webpack_public_path__ + "static/media/image.3b1f7105.png";